const BASE_URL = process.env.REACT_APP_BASE_URL;

// FORECAST PRODUCTS ENDPOINTS
export const forecastProductsEndpoints = {
  GET_FORECAST_HOURS: BASE_URL + '/forecast-products/getForecastHours',
  GET_MEDIUM_FORECAST_MODEL_CHARTS:
    BASE_URL + '/forecast-products/getAllGlobalForecastProducts',
  GET_SHORT_FORECAST_MODEL_CHARTS:
    BASE_URL + '/forecast-products/getAllRegionalForecastProducts',
  GET_ENSEMBLE_FORECAST_MODEL_CHARTS:
    BASE_URL + '/forecast-products/getAllEnsembleForecastProducts',
  GET_EXTENDED_FORECAST_MODEL_CHARTS:
    BASE_URL + '/forecast-products/getAllExtendedForecastProducts',
  GET_ALL_FORECAST_MODELS: BASE_URL + '/forecast/all-models',
  GET_ALL_MODEL_FORECAST_PRODUCTS: BASE_URL + '/forecast/forecast-products',
  GET_SPECIAL_ALL_PRODUCTS:
    BASE_URL + '/special-products/generate-forecast-url',
};

export const allJobsOpeningsEndpoints = {
  GET_ALL_JOBS: BASE_URL + '/all/listedopenings', // Update with your actual endpoint
};

// New job application endpoint
export const jobApplicationEndpoints = {
  APPLY_JOB: BASE_URL + '/apply',
};

// Endpoint for all EMP
export const employeesList = {
  GET_ALL_EMPLOYEES: BASE_URL + '/employees/list',
};

// End for a Special_Products_Names
export const specialProducts = {
  GET_ALL_SPECIAL_PRODUCTS_NAMES: BASE_URL + '/special-products/getAllProducts',
};

export const authEndpoints = {
  LOGIN_URL: BASE_URL + '/auth/login',
  REGISTER_URL: BASE_URL + '/auth/register',
};

// PUBLICATIONS ENDPOINTS
export const publicationsEndpoints = {
  GET_PUBLICATIONS_BY_YEAR: BASE_URL + '/publications/publication',
  GET_INTERNAL_REPORTS: BASE_URL + '/publications/reports',
};
